import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../shared/services/user/user.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard {
  constructor(
    private userService: UserService,
    private router: Router,
  ) {}

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<Observable<boolean> | Promise<boolean | UrlTree> | boolean> {
    const user = await this.getRoles();

    const isSeller = user.is_seller;
    const isBuyer = user.is_buyer;
    const isAdmin = user.is_admin;

    if (isAdmin) {
      return true;
    }

    // data.role may be a single role or an array of allowed roles.
    const allowedRoles = [].concat(next.data.role || []);
    if (
      allowedRoles.length &&
      !allowedRoles.some(role => user.roles.includes(role))
    ) {
      if (isBuyer) {
        this.router.navigate(['/buyer-home']);
      } else if (isSeller) {
        this.router.navigate(['/seller-home']);
      } else if (isAdmin) {
        this.router.navigate(['/admin/home']);
      } else {
        this.router.navigate(['/']);
      }
      return true;
    }

    return true;
  }

  async getRoles() {
    const currentUser = await this.userService.getMe().toPromise();
    return currentUser.data;
  }
}
